export default function initCheck() {
    const integer = document.querySelectorAll<HTMLInputElement>('.integer');
    const decimal = document.querySelectorAll<HTMLInputElement>('.decimal');
    //const date = document.querySelector<HTMLInputElement>('#projet_form_information_du_participant_date_de_creation')
    //check integer value
    integer.forEach(function(elt) {
        elt.addEventListener('keypress', e => {
            if (!e.key.match(/[0-9]/)) {
                e.preventDefault();

                return false;
            }

            return;
        });
    });
    //check decimal value
    decimal.forEach(function(elt) {
        elt.addEventListener('keypress', e => {
            if (!e.key.match(/[0-9.,]/)) {
                e.preventDefault();

                return false;
            }

            return;
        });
    });
}

